import { QuizPlayerContentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerContent';
import { PerformanceEvaluationStatusEnum } from '@/types/schema';

import getQuizModifiedAttempts from '../../../../QuizDetails/utils/getQuizModifiedAttempts';
import { QuestionPerformanceFragment } from '../../../graphql/fragments/generated/QuestionPerformance';
import { QuizPerformanceFragment } from '../../../graphql/fragments/generated/QuizPerformance';
import {
  QuestionAttemptType,
  QuizPlayerReviewContentProps,
} from '../components/QuizPlayerReviewContent/types';

export const getAttemptFromId = (attemptId: string, quizPerformance: QuizPerformanceFragment) => {
  const attempts = getQuizModifiedAttempts(quizPerformance);
  return attempts.find((attempt) => attempt.attemptId === attemptId);
};

interface Params extends Pick<QuizPlayerReviewContentProps, 'quizAttempt' | 'questionAttemptById'> {
  content: QuizPlayerContentFragment;
}

export const isReviewDataValid = ({ content, quizAttempt, questionAttemptById }: Params) => {
  const correctAnswersCount = content.quizQuestionsConfig.questions.filter((question) => {
    const attempt = questionAttemptById[question.id];
    return attempt?.evaluationStatus === PerformanceEvaluationStatusEnum.Correct;
  }).length;

  return {
    isValid: quizAttempt?.correctAnswersCount === correctAnswersCount,
    correctAnswersCount,
    quizAttemptCorrectAnswersCount: quizAttempt?.correctAnswersCount,
    attemptsInfo: Object.entries(questionAttemptById).map(([questionId, attempt]) => ({
      questionId,
      isSubmitted: attempt.isSubmitted,
      evaluationStatus: attempt.evaluationStatus,
    })),
  };
};

const evaluationStatus = PerformanceEvaluationStatusEnum.InCorrect;
const isSubmitted = true;

export const getAttemptFromQuestionPerformance = (
  performance: QuestionPerformanceFragment,
  parentAttemptId: string,
): QuestionAttemptType => {
  if (performance.parentAttemptId === parentAttemptId) {
    return {
      evaluationStatus: performance.evaluationStatus ?? evaluationStatus,
      isSubmitted,
      submission: performance.submission,
    };
  }

  const attempt = performance.attempts.find((a) => a.parentAttemptId === parentAttemptId);

  return {
    evaluationStatus: attempt?.evaluationStatus ?? evaluationStatus,
    isSubmitted,
    submission: attempt?.submission,
  };
};
